import { useState } from "react";
import { Plus, X } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

const DAYS = [
  { k: "0", label: "Lunedì" },
  { k: "1", label: "Martedì" },
  { k: "2", label: "Mercoledì" },
  { k: "3", label: "Giovedì" },
  { k: "4", label: "Venerdì" },
  { k: "5", label: "Sabato" },
  { k: "6", label: "Domenica" },
];

export function WeeklySlotsEditor({ value, onChange }) {
  const slots = value || {};
  const [drafts, setDrafts] = useState({});

  const addSlot = (day) => {
    const t = (drafts[day] || "").trim();
    if (!/^\d{2}:\d{2}$/.test(t)) return;
    const cur = slots[day] || [];
    if (cur.includes(t)) return;
    onChange({ ...slots, [day]: [...cur, t].sort() });
    setDrafts({ ...drafts, [day]: "" });
  };

  const removeSlot = (day, t) => {
    onChange({ ...slots, [day]: (slots[day] || []).filter((x) => x !== t) });
  };

  return (
    <div className="space-y-3" data-testid="weekly-slots-editor">
      {DAYS.map((d) => (
        <div key={d.k} className="rounded-lg border border-slate-200 p-3">
          <div className="flex items-center justify-between">
            <span className="text-sm font-600 text-slate-900">{d.label}</span>
            <div className="flex items-center gap-1">
              <Input
                type="time"
                value={drafts[d.k] || ""}
                onChange={(e) => setDrafts({ ...drafts, [d.k]: e.target.value })}
                className="h-8 w-28"
                data-testid={`slot-time-input-${d.k}`}
              />
              <Button type="button" size="sm" variant="outline" className="h-8 px-2"
                onClick={() => addSlot(d.k)} data-testid={`add-slot-btn-${d.k}`}>
                <Plus className="h-4 w-4" />
              </Button>
            </div>
          </div>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {(slots[d.k] || []).length === 0 ? (
              <span className="text-xs text-slate-400">Nessuno slot</span>
            ) : (
              (slots[d.k] || []).map((t) => (
                <span key={t} className="flex items-center gap-1 rounded-full bg-sky-50 py-1 pl-2.5 pr-1 text-xs font-600 text-blue-700">
                  {t}
                  <button type="button" onClick={() => removeSlot(d.k, t)} className="rounded-full p-0.5 hover:bg-sky-100" data-testid={`remove-slot-${d.k}-${t}`}>
                    <X className="h-3 w-3" />
                  </button>
                </span>
              ))
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
